package kz.dentalcrm.app.data

import kz.dentalcrm.app.core.utils.Result
import kz.dentalcrm.app.core.utils.map
import kz.dentalcrm.app.data.network.QuickRepliesApi
import kz.dentalcrm.app.data.network.response_model.quick_replies.QuickReply
import kz.dentalcrm.app.domain.QuickRepliesRepository

class QuickRepliesRepositoryImpl(
    private val quickRepliesApi: QuickRepliesApi
) : QuickRepliesRepository {

    override suspend fun getQuickReplies(page: Int): Result<List<QuickReply>?> =
        quickRepliesApi.getQuickReplies(page = page)

    override suspend fun addQuickReply(message: String): Result<Any?> =
        quickRepliesApi.addQuickReply(message = message)

    override suspend fun updateQuickReply(id: Int, message: String): Result<Any?> =
        quickRepliesApi.updateQuickReply(id = id, message = message)

    override suspend fun deleteQuickReply(id: Int): Result<Any?> =
        quickRepliesApi.deleteQuickReply(id = id)
}
